var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-container"},[_c('NavBar'),_c('div',{staticClass:"container my-4"},[_c('router-view')],1)],1),_c('Footer',{staticClass:"app-footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }